import React from 'react';
import {
  IonPage,
  IonContent,
  IonText,
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardContent,
  IonBadge,
} from '@ionic/react';
import { documentOutline, homeOutline, arrowBackOutline } from 'ionicons/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts';
import styles from './NotFound.module.scss';
import { useTranslation } from 'react-i18next';

type NotFoundLocationState = {
  from?: string;
};

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { authState } = useAuth();

  const state = location.state as NotFoundLocationState | null;
  const homePath = authState?.isLoggedIn ? '/tabs/dashboard' : '/login';
  const backPath = state?.from;

  const handleGoBack = () => {
    if (location.key !== 'default') {
      navigate(-1);
      return;
    }

    const target = backPath && backPath !== '/404' && backPath !== location.pathname
      ? backPath
      : homePath;
    navigate(target, { replace: true });
  };

  const handleGoHome = () => {
    navigate(homePath, { replace: true });
  };

  return (
    <IonPage className={styles.page}>
      <IonContent className={styles.content}>
        <IonGrid className={styles.shell}>
          <IonRow className={styles.shellRow}>
            <IonCol size="12" sizeMd="10" sizeLg="8" className={styles.shellCol}>
              <IonCard className={styles.card}>
                <IonCardContent>
                  <IonBadge className={styles.badge}>404</IonBadge>

                  <IonButton fill="clear" className={styles.iconWrap} aria-label={t('pages.unauthenticated.NotFound.notFound')}>
                    <IonIcon icon={documentOutline} className={styles.icon} />
                  </IonButton>

                  <IonText className={styles.title}>{t('pages.unauthenticated.NotFound.pageNotFound')}</IonText>
                  <IonText className={styles.subtitle}>{t('pages.unauthenticated.NotFound.thePageYouRequestedIsNot')}</IonText>
                  <IonText className={styles.detail}>{t('pages.unauthenticated.NotFound.itMayHaveBeenMovedRemoved')}</IonText>

                  <IonRow className={styles.actions}>
                    <IonCol size="auto" className={styles.actionCol}>
                      <IonButton fill="clear" className={styles.secondaryBtn} onClick={handleGoBack}>
                        <IonIcon icon={arrowBackOutline} />{t('pages.unauthenticated.NotFound.back')}
                      </IonButton>
                    </IonCol>
                    <IonCol size="auto" className={styles.actionCol}>
                      <IonButton fill="clear" className={styles.primaryBtn} onClick={handleGoHome}>
                        <IonIcon icon={homeOutline} />{t('pages.unauthenticated.NotFound.home')}
                      </IonButton>
                    </IonCol>
                  </IonRow>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default NotFound;
